import { Component, Node, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';
import UserModel from '../../../../../tableEngine/Script/Game/Data/Model/UserModel';
import NumberFormatter from '../../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import MultiThemeSource from '../../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeSource';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('LobbyBalance')
@requireComponent([NumberFormatter, MultiThemeSource])
export default class LobbyBalance extends Component {
    private static _displayInOriginalUnit: boolean = true;

    @property(Node)
    private readonly touchArea: Node = null;

    private _numberFormatter: NumberFormatter;
    private _multiThemeSource: MultiThemeSource;
    private _displayInOriginalUnit: boolean = false;

    private get numberFormatter(): NumberFormatter {
        if (!this._numberFormatter) {
            this._numberFormatter = this.getComponent(NumberFormatter);
        }
        return this._numberFormatter;
    }

    private get multiThemeSource(): MultiThemeSource {
        if (!this._multiThemeSource) {
            this._multiThemeSource = this.getComponent(MultiThemeSource);
        }
        return this._multiThemeSource;
    }

    private get displayInOriginalUnit(): boolean {
        return this._displayInOriginalUnit;
    }
    private set displayInOriginalUnit(value: boolean) {
        if (this._displayInOriginalUnit === value) {
            return;
        }
        this._displayInOriginalUnit = value;
        LobbyBalance._displayInOriginalUnit = value;
        this._onDisplayUnitChanged();
    }

    protected onLoad() {
        // this.touchArea.on(Node.EventType.TOUCH_END, this._toggleDisplayUnit, this);
        Lobby.user.on(UserModel.EVENT_TYPE.BALANCE_CHANGED, this._updateBalance, this);
    }

    protected onEnable() {
        this.displayInOriginalUnit = LobbyBalance._displayInOriginalUnit;
        this._onDisplayUnitChanged();
    }

    // private _toggleDisplayUnit() {
    //     this.displayInOriginalUnit = !this.displayInOriginalUnit;
    // }

    private _onDisplayUnitChanged() {
        // if (this._displayInOriginalUnit && FeatureGame.user.currency) {
        this.numberFormatter.textTemplate = `${Lobby.user.currency ?? ''} \${0}`;
        this.multiThemeSource.theme = 1;
        // } else {
        //     this.numberFormatter.textTemplate = `\${0}`;
        //     this.multiThemeSource.theme = 0;
        // }
        this._updateBalance();
    }

    private _updateBalance() {
        this.numberFormatter.value = Lobby.user.transformToCurrency(Lobby.user.balance);
        // this.numberFormatter.value = NumberPrecision.times(balanceInDollar, this.displayInOriginalUnit ? FeatureGame.user.currencyRatio : 1);
        this.numberFormatter.updateTextDisplay();
    }
}
